export const name = 'measuresApi' as const
export const MeasuresApiSymbol = Symbol('measuresApiSymbol')
